import "core-js/modules/es.array.push.js";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import Error from "@/views/error/error.vue";
import LogisticCostList from "@/components/shipping/LogisticCostList.vue";
import ImportersList from "@/components/importers/ImportersList.vue";
export default {
  name: "shipping",
  components: {
    Error: Error,
    LogisticCostList: LogisticCostList,
    ImportersList: ImportersList
  },
  props: {
    loggedUserData: Object
  },
  data: function data() {
    return {
      selectedTab: null,
      tabs: {
        logisticCost: "logisticCost",
        importers: "importers"
      }
    };
  },
  computed: {
    canManageLogisticCost: function canManageLogisticCost() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_SHIPPING);
    },
    canManageImporters: function canManageImporters() {
      return hasRole(process.env.VUE_APP_ROLES_MANAGE_IMPORTERS);
    },
    isAuthorized: function isAuthorized() {
      return isAdminNotConsultant(this.loggedUserData) && (this.canManageLogisticCost || this.canManageImporters);
    }
  },
  watch: {
    $route: function $route() {
      if (this.selectedTab != this.tabs[this.$route.query.tab]) {
        this.changeTab();
      }
    },
    selectedTab: function selectedTab(newVal, oldVal) {
      this.changeTab();
    }
  },
  created: function created() {
    this.changeTab();
  },
  methods: {
    selectTab: function selectTab(name) {
      this.selectedTab = this.tabs[name];
      this.$router.push({
        query: {
          tab: this.tabs[name]
        }
      }).catch(function () {});
    },
    changeTab: function changeTab() {
      if (this.$route.query.tab) {
        this.selectedTab = this.tabs[this.$route.query.tab];
      } else if (this.selectedTab) {
        this.selectedTab = this.tabs[this.selectedTab];
      } else {
        this.selectedTab = this.canManageLogisticCost ? this.tabs.logisticCost : this.tabs.importers;
      }
    },
    isAdminNotConsultant: isAdminNotConsultant
  }
};